import React from "react";
import LoanSection from "./LoanSection"; // Import LoanSection component

function App() {
  return (
    <div className="App">
      <h1>My Blockchain Bank</h1>
      <LoanSection /> {/* Render LoanSection component */}
    </div>
  );
}

export default App;
